import React from 'react'
import {useTranslation} from 'react-i18next'
import {Form} from 'antd'
import {Select} from '@/components'
import {NEW_PAYMENT_STORES} from '@/constants/playwright-ids'

export const TerminalSelectField: React.FC<{options: any[]}> = ({options}) => {
    const {t} = useTranslation()
    const hasMultipleOptions = options?.length >= 2

    return (
        <Form.Item
            hidden={!hasMultipleOptions}
            label={t('TerminalSelectField.labels.stores')}
            name='terminalId'
            rules={
                hasMultipleOptions
                    ? [{required: true, message: t('TerminalSelectField.errors.storeRequired')}]
                    : []
            }
        >
            <Select
                placeholder={t('TerminalSelectField.labels.stores')}
                options={options}
                data-test-id={NEW_PAYMENT_STORES}
            />
        </Form.Item>
    )
}
